import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L, ModuleFE_Dialog, ModuleFE_Print, ModuleFE_Toaster, TS_Printable } from '@nu-art/thunderstorm-frontend/index';
import './Dialog_ExportOrderMapping.scss';
import { TS_InputV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_Input/index';
import { Printable_OrderMapper } from './Printable_OrderMapping.js';
import { ModuleFE_OrderConfiguration } from '../../../../../_entity/installation/index.js';
import { exportOrderMappingAsCSV } from './ExportOrderMappingCSV.js';
const getFilteredOrders = (installationId, date) => {
    return ModuleFE_OrderConfiguration.cache.filter(order => order.ehrInstallationId === installationId && order.__updated > Number(date));
};
export class Dialog_ExportOrderMapping extends ComponentSync {
    //######################### Life Cycle #########################
    static show = (data) => {
        ModuleFE_Dialog.show({ content: _jsx(Dialog_ExportOrderMapping, { ...data }) });
    };
    deriveStateFromProps(nextProps, state) {
        state.selectedDate ??= '';
        state.installationOrders = getFilteredOrders(nextProps.installationId, state.selectedDate);
        return state;
    }
    //######################### Logic #########################
    onInputChange = (date) => {
        const installationOrders = ModuleFE_OrderConfiguration.cache.filter(installationOrder => installationOrder.ehrInstallationId === this.props.installationId && installationOrder.__updated > Number(date));
        this.setState({ selectedDate: date, installationOrders });
    };
    onClickExportOrder = async () => {
        if (this.props.exportAsCsv) {
            exportOrderMappingAsCSV({
                installationId: this.props.installationId,
                installationOrders: this.state.installationOrders
            });
            ModuleFE_Dialog.close();
            return;
        }
        if (!this.state.printableOrderMappingRef)
            return ModuleFE_Toaster.toastError('Failed export order mapping, try again later...');
        await ModuleFE_Print.printElement(this.state.printableOrderMappingRef, [{
                key: 'theme',
                value: 'light'
            }]);
        ModuleFE_Dialog.close();
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { className: 'quai-manager-ui__export-order-mapping-dialog', id: this.props.id, children: [this.renderHeader(), this.renderInput(), this.renderButtons(), this.renderPrintableOrderMapper(this.props.installationId)] });
    }
    renderHeader = () => {
        return _jsx(LL_H_C, { className: 'quai-manager-ui__export-order-mapping-dialog__header', children: "Select Date" });
    };
    renderInput = () => {
        return _jsx(TS_InputV2, { type: 'number', value: this.state.selectedDate, onChange: this.onInputChange, placeholder: 'No date, get all orders' });
    };
    renderButtons = () => {
        const installationOrdersLength = this.state.installationOrders.length;
        const exportLabel = this.props.exportAsCsv ? 'Export CSV' : 'Export';
        return _jsx(Button, { className: 'quai-manager-ui__export-order-mapping-dialog__btn', variant: 'primary', onClick: this.onClickExportOrder, disabled: installationOrdersLength === 0, children: `${exportLabel} ${installationOrdersLength} orders` }, 'submit-export-order');
    };
    renderPrintableOrderMapper = (installationOrderId) => {
        if (this.props.exportAsCsv)
            return null;
        const installationOrders = this.state.installationOrders;
        return _jsx(TS_Printable, { printOnly: true, printable: async (p) => this.setState({ printableOrderMappingRef: p }), children: _jsx(Printable_OrderMapper, { installationId: installationOrderId, installationOrders: installationOrders }, installationOrders.join('')) });
    };
}
//# sourceMappingURL=Dialog_ExportOrderMapping.js.map